import React from 'react';
export function Footer() {
  return <footer className="py-12 bg-[#050505] border-t border-[#c9a84c]/20" data-id="element-103">
      <div className="container mx-auto px-4 md:px-6" data-id="element-104">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-105">
          <div className="text-2xl font-bold tracking-tighter text-white" data-id="element-106">
            AI<span className="text-[#c9a84c]" data-id="element-107">.WEB</span>
          </div>

          <div className="flex gap-8 text-sm text-gray-500" data-id="element-108">
            <a href="#" className="hover:text-[#c9a84c] transition-colors" data-id="element-109">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-[#c9a84c] transition-colors" data-id="element-110">
              Terms of Service
            </a>
            <a href="#" className="hover:text-[#c9a84c] transition-colors" data-id="element-111">
              Cookies
            </a>
          </div>

          <div className="text-sm text-gray-600" data-id="element-112">
            © {new Date().getFullYear()} AI.WEB Package. All rights reserved.
          </div>
        </div>
      </div>
    </footer>;
}